// extracted by mini-css-extract-plugin
export default {"sharingMenuInvite":"style_sharingMenuInvite__1wrTJ","sharingMenuInput":"style_sharingMenuInput__jIhsu","sharingMenuInviteButton":"style_sharingMenuInviteButton__uMjwa"};